module.exports = __webpack_public_path__ + "static/media/flower2.44cd613e.png";